import { cx } from '@linaria/core';
import { tableCls, defaultStylingTableCls, wrapperCls } from './table.style.js';
import { jsx } from 'react/jsx-runtime';

function Table({
  children,
  bordered,
  striped,
  hover,
  alternative,
  responsive
}) {
  return /*#__PURE__*/jsx("div", {
    className: cx(wrapperCls, alternative && "alternative", responsive && "responsive", bordered && "bordered", striped && "striped", hover && "hover"),
    children: /*#__PURE__*/jsx("table", {
      className: cx(tableCls, defaultStylingTableCls),
      children: children
    })
  });
}

export { Table };
//# sourceMappingURL=table.js.map
